import { css } from "theme/default/css";

export const setFlexDFF1 = css`
  display: flex;
  flex: 1;
`;
